import React, { useState, useEffect, useLayoutEffect } from "react"
import {connect, useSelector} from "react-redux"
import Parse from "parse"
import makeStyles from "@mui/styles/makeStyles"

import ReceptionHeader from "../../components/Reception/ReceptionHeader"
import GlobalStyles from "../../components/Reception/GlobalStyle"
import LeftSideWrapper from "../../components/Reception/LeftSideWrapper"
import RightSideWrapper from "../../components/Reception/RightSideWrapper"
import FullScreenWrapper from "../../components/FullScreenWrapper"
import Filter from "../../components/Reception/Filter"
import GroupItems from "../../components/Reception/GroupItems"
import ButtonFlaw from "../../components/Reception/ButtonFlaw"
import ActionContent from "../../components/Reception/ActionContent"
import ModalWrapper from "../../components/Reception/ModalWrapper"
import ActionHeaderText from "../../components/Reception/ActionHeaderText"
import ReceptionSnackBar from "../../components/Reception/ReceptionSnackBar"
import ActionFlawContent from "../../components/Reception/ActionFlawContent"
import { checkTablet } from "../../utils"
import {
	closeReceptionDetailSnackBar,
	showReceptionInterface,
	updateProductStock,
	updateStatus,
	filterByStatus,
	filterByNameOrCode,
	resetStatus,
	showErrors,
	loadReception,
	validateAddDisplay
} from "../../actions/Reception/reception"
import {findProductStock} from "../../utils/receptionUtils"
import { CAN_UPDATE_PRODUCT_STOCK } from "../../utils/accessRights"
import ListToShowTable from "../../components/Reception/ListToShowTable"
import { setSearchValue } from "../../utils"
import { getProductTypeOptionsSelector } from "../../reducers/ProductTypes/productTypes"
import { getFCCurrentStock } from "../../api/fcStock"
import { hasAnyStockToBreak } from "../../utils/stockTypes"

const useStyles = makeStyles(() => ({
	filter: {
		position: "relative",
		width: "100%",
		marginTop: 64
	}
}))

const Reception = (props) => {
	const {
		selectedHub,
		
		selectedDate,
		formattedReceptionData,
		update,
		showReceptionInterface,
		resetStatus,
		filterByStatus,
		filterByNameOrCode,
		updateStatus,
		updateProductStock,
		receptionSnackBar,
		closeReceptionDetailSnackBar,
		originalReceptionData,
		showErrors,
		canEdit,
		noDisplay,
		loadReception,
		validateAddDisplay
	} = props

	const classes = useStyles()

	// constants
	const user = Parse.User.current()
	const hub = (selectedHub)?selectedHub[0].name:""

	// selected card state
	const [selectedCard, setSelectedCard] = useState([])
	const [open, setOpen] = useState(false)
	const [openList, setOpenList] = useState(false)
	const [step, setStep] = useState(0)
	const [stepFlaw, setStepFlaw] = useState(0)
	const [status, setStatus] = useState("TODO")
	const [firstInput, setFirstInput] = useState()
	const [confirmInput, setConfirmInput] = useState()
	const [lostInput, setLostInput] = useState("")
	const [lostReason, setLostReason] = useState()
	const [lostVolume, setLostVolume] = useState(0)
	const [receptionData, setReceptionData] = useState(formattedReceptionData)
	const [flawProduct, setFlawProduct] = useState()
	const [flawOrigin, setFlawOrigin] = useState(null)
	const hasRetailOffer = Boolean(selectedHub && selectedHub[0] && selectedHub[0].activeRetailOffer)
	const [flawDlc, setFlawDlc] = useState("")
	const [selectedFlaw, setSelectedFlaw] = useState([])
	const [focusSearch, setFocusSearch] = useState(true)
	const listToShow = originalReceptionData.filter(elm => !elm.display)
	const [productSelected, setProductSelected] = useState([])
	const [searchValue, updateSearchValue] = useState("")
	const productTypeOptions = useSelector(getProductTypeOptionsSelector)
	// KFC-284: already-committed volume (pre-orders + pending carts), to keep in click & collect.
	const [preordersVolume, setPreordersVolume] = useState(0)
	const [valuesByStep, setValuesByStep] = useState({
		1: {
			foodcheri: "",
			fridgeRetail: ""
		}
	})

	// for device connected
	const [isTablet, setIsTablet] = useState(checkTablet)

	// effect on receptionData change
	// type array of objects
	useEffect(() => {
		setReceptionData(formattedReceptionData)
	}, [update])

		// back to filter if no hub selected
	useEffect(() => {
		if (!selectedHub) {
			showReceptionInterface()
		}

		const storage = JSON.parse(localStorage.getItem("searchValue"))
		if (storage && storage.reception) {
			updateSearchValue(storage.reception)
			filterByNameOrCode(storage.reception)
		}
	}, [])

	// focus search input
	useEffect(() => {
		if (step === 0) setFocusSearch(true)
		if (step !== 0) setFocusSearch(false)
	}, [step])

		// set isTablet state
		useLayoutEffect(() => {
				const checkisTablet = () => {
						setIsTablet(checkTablet())
				}

				// title
				document.title = "Réception - KFC"

				// check size
				window.addEventListener("resize", checkisTablet)

				// remove check
				return () => window.removeEventListener("resize", checkisTablet)
		}, [])

		// open modal
		const handleClickOpenModal = () => {
				setOpen(true)
		}

	// open list modal
	const handleOpenListModal = () => {
		if (listToShow.length !== 0) {
			setOpenList(true)
		} else {
			showErrors("Aucun produit à ajouter")
		}
	}

		// close modal
		const handleCloseModal = async () => {
		if (stepFlaw > 0) {
			setStepFlaw(0)
			setFlawOrigin(null)
			resetLost()

			if (open) setOpen(false)
			return
		}

				setStep((step === 0)?0:step - 1)

				// close modal then undo selection
				if (step === 1) {
					await resetStatus(selectedCard)
						resetSelection()
				}
		}

	// close list modal
	const handleCloseListModal = () => {
		setOpenList(false)
	}

		const resetSelection = () => {
			setSelectedCard([])

			if (open) setOpen(false)
		}

		// on filter by status
		const onStatusChange = (selectedStatus) => {
			setStatus(selectedStatus)
			filterByStatus(selectedStatus)
		}

	// on filter by name or code
	// The field is uncontrolled, so this state is the only copy of the search that survives the
	// field being unmounted — which is what the flaw declaration does.
	const onNameChange = (nameOrCode) => {
		updateSearchValue(nameOrCode)
		filterByNameOrCode(nameOrCode)
		setSearchValue(nameOrCode, "reception")
	}

		// on set flaw
		const onSetFlaw = () => {
		if (canEdit) {
			setStepFlaw(1)

			// open action in modal
			if (isTablet) {
				handleClickOpenModal()
			}
		}
		}

		// action on page quit
		const onClose = () => {
				filterByNameOrCode("")
				setSearchValue("", "reception")
				showReceptionInterface()
		}

  const handleCardClick = async (element) => {
		if (selectedCard.length !== 0) await resetStatus(selectedCard)
		await updateStatus(element)

		setSelectedCard(element)
		setStep(1)

		// Cleared on every card, so a retail product never inherits the previous one's pre-orders
		// — it is set again below only for hubs with an active retail offer.
		setPreordersVolume(0)

		// Reinitialize form values for retail
		setValuesByStep({
			1: {
				foodcheri: "",
				fridgeRetail: ""
			}
		})

		const isRetail = selectedHub?.[0].activeRetailOffer
		if (isRetail) {
			const stock = element.productDispatch
				? await getFCCurrentStock(element.productDispatch.objectId, selectedHub[0].objectId)
				: null

			// Unknown stock: open without the pre-order constraint rather than return, which
			// would skip the modal below and leave the tablet half-open.
			if (null !== stock) {
				// KFC-284: FoodCheri only returns what is still available (stock minus pending carts).
				// The already-committed volume is deduced from the dispatched volume, which KFC knows:
				//   committed = initialVolume - available
				// That number covers pre-orders AND pending carts, so it slightly overestimates
				// pre-orders alone. This errs on the safe side of the business rule: keep enough in
				// click & collect for everything customers have already engaged.
				setPreordersVolume(Math.max((element.initialVolume || 0) - stock, 0))
			}
		}

			// open action in modal
			if (isTablet) {
					handleClickOpenModal()
			}
	}

	const directValidation = async (input, retailInput) => {
		await updateProductStock({ productStock: selectedCard, volume: input, type: "RECEPTION", volumeLibreService: retailInput })
		resetSelection()
		setStep(0)
	}

	const handleValidate = async (e) => {
		e.preventDefault()

		if (step === 1) {
			if (selectedCard.initialVolume === parseInt(firstInput)) {
				directValidation(firstInput)
				return
			}
		}

		if (step === 2) {
			if (selectedCard.initialVolume <= parseInt(confirmInput)) {
				directValidation(confirmInput)
				return
			}

			setLostVolume(selectedCard.initialVolume - parseInt(confirmInput))
		}

		if (step === 3) {
			if (lostReason === "") {
				showErrors("Veuillez sélectionner un motif")
				return
			}

			const lost = {
				"volume": lostVolume,
				"reason": lostReason,
				"explanation": lostInput,
				"isInventory": false
			}

			const hub = selectedHub?.[0]

			if (hub?.activeRetailOffer) {
				const step2Values = valuesByStep[2] || {}
				// Convert string values to numbers, defaulting to 0
				const foodcheriVol = parseInt(step2Values.foodcheri) || 0
				const retailVol = parseInt(step2Values.fridgeRetail) || 0
				
				await updateProductStock({
					productStock: selectedCard,
					volume: foodcheriVol,
					lost,
					volumeLibreService: retailVol,
					type: "RECEPTION"
				})
			} else {
				await updateProductStock({ productStock: selectedCard, volume: confirmInput, lost, type: "RECEPTION" })
			}
			
			resetSelection()
			resetLost()
			setStep(0)
			return
		}

		setStep(step + 1)
	}

	const handleSubmitWithRetail = async (values) => {
		// Convert to numbers, treating empty/invalid as 0
		const foodcheriVolume = parseInt(values.foodcheri) || 0
		const fridgeRetailVolume = parseInt(values.fridgeRetail) || 0
		const totalVolume = foodcheriVolume + fridgeRetailVolume
		
		if (step === 1) {
			const isEqual = selectedCard.initialVolume === totalVolume
			if (isEqual) {
				directValidation(foodcheriVolume, fridgeRetailVolume)
				return
			}
		}

		if (step === 2) {
			const hasLoss = selectedCard.initialVolume > totalVolume

			if (!hasLoss) {
				directValidation(foodcheriVolume, fridgeRetailVolume)
				return
			}

			const lostVol = selectedCard.initialVolume - totalVolume
			setLostVolume(lostVol)
		}

		// Step 3 is handle by handleValidate
		setStep(step + 1)
	}

	const handleFlawValidate = async (e) => {
		e.preventDefault()

		let products

		switch (stepFlaw) {
			case 1:
				products = findProductStock(originalReceptionData, flawProduct)
				setSelectedFlaw(products)

				if (products.length === 0) showErrors("Ce produit n'est pas sensé être en vente")
				if (products.length === 1) {
					if (products[0].receptionStatus !== "DONE") {
						showErrors("Ce produit n'est pas encore réceptionné")
						return
					}
					if (!hasAnyStockToBreak(products[0])) {
						showErrors("Le stock est vide sur ce produit, impossible de déclarer de la casse")
						return
					}
					setStepFlaw(3)
				}
				if (products.length > 1) setStepFlaw(2)

				return
			case 2:
				products = findProductStock(originalReceptionData, flawProduct, flawDlc)
				setSelectedFlaw(products)

				if (products.length === 0) showErrors("Aucun Produit trouvé")
				if (products.length > 0) {
					if (products[0].receptionStatus !== "DONE") {
						showErrors("Ce produit n'est pas encore réceptionné")
						return
					}

					if (!hasAnyStockToBreak(products[0])) {
						showErrors("Le stock est vide sur ce produit, impossible de déclarer de la casse")
						return
					}
					setStepFlaw(3)
				}

				return
			case 3:
				if (lostReason === "") {
					showErrors("Veuillez sélectionner un motif")
					return
				}

				const lost = {
					"volume": lostVolume,
					"reason": lostReason,
					"explanation": lostInput,
					"isInventory": false,
					"stockType": flawOrigin || undefined
				}
				await updateProductStock({ productStock: selectedFlaw[0], volume: lostVolume, lost, type: "LOSS" })
				setStepFlaw(0)
				setFlawOrigin(null)
				resetLost()

				return
			default:
				setStepFlaw(stepFlaw + 1)
		}
	}

	const inputActionChange = (value) => {
		if (step === 1) setFirstInput(value)
		if (step === 2) setConfirmInput(value)
		if (step === 3) setLostInput(value)
	}

	const handleChangeInputWithRetail = (values) => {
		setValuesByStep({
			...valuesByStep,
			[step]: values
		})
	}

	const inputFlawActionChange = (value) => {
		if (stepFlaw === 1) setFlawProduct(value)
		if (stepFlaw === 2) setFlawDlc(value)
		if (stepFlaw === 3) setLostInput(value)
	}

	const resetLost = () => {
		setLostVolume(0)
		setLostInput("")
		setLostReason("")
		setFlawDlc("")
		setFlawProduct("")
	}

	const refresh = () => {
		const storage = JSON.parse(localStorage.getItem("receptionFilter"))
		if (storage) loadReception(storage.date, storage.brand, storage.hub)
	}

	// toggle product in selection
	const toggleProduct = (product) => {
		if (productSelected.includes(product.objectId)) {
			setProductSelected(productSelected.filter(elm => elm !== product.objectId))
		} else {
			setProductSelected([...productSelected, product.objectId])
		}
	}

	const validateDisplay = async () => {
		if (productSelected.length > 0) {
			await validateAddDisplay(productSelected)
			setOpenList(false)
		} else {
			showErrors("Sélectionner des produits à afficher")
		}
	}

		const getAction = () => {
		if (stepFlaw > 0) {
			return (
				<ActionFlawContent
					stepFlaw={stepFlaw}
					handleClose={handleCloseModal}
					handleValidate={handleFlawValidate}
					setValue={inputFlawActionChange}
					isTablet={isTablet}
					flawProduct={flawProduct}
					flawDlc={flawDlc}
					lostActionInfos={[lostVolume, setLostReason, setLostVolume]}
					productStock={selectedFlaw && selectedFlaw[0]}
					hasTwoStocks={hasRetailOffer}
					onOriginChange={setFlawOrigin}
				/>
			)
		}

				return (
						<ActionContent
							step={step}
							lostActionInfos={[lostVolume, setLostReason]}
							textHeader={(
									<ActionHeaderText
											selectedCard={selectedCard}
											productTypeOptions={productTypeOptions}
									/>
							)}
							selectedCard={selectedCard}
							openModal={() => {}}
							handleClose={handleCloseModal}
							handleValidate={handleValidate}
							onSubmitWithRetail={handleSubmitWithRetail}
							setValue={inputActionChange}
							onChangeInputWithRetail={handleChangeInputWithRetail}
							valuesByStep={valuesByStep}
							isTablet={isTablet}
							noDisplay={noDisplay}
							hub={selectedHub?.[0]}
							preordersVolume={preordersVolume}
						/>
				)
		}

		const listKeys = Object.keys(receptionData)

		return (
				<FullScreenWrapper>
						{/*
						  * Declaring a flaw takes over the page, so the page chrome goes with it:
						  * the header and its way back out, and the filter row, which has no
						  * product list left to act on. The row also carries the clearance under
						  * the fixed header, so the two leave together.
						  */}
						{stepFlaw === 0 &&
							<>
								{/* page header */}
								<ReceptionHeader user={user} date={selectedDate} hub={hub} onClose={onClose}/>
								<div className={classes.filter}>
									{/* filter upon device */}
									<Filter
										onStatusChange={onStatusChange}
										onSetFlaw={onSetFlaw}
										onNameChange={onNameChange}
										status={status}
										isTablet={isTablet}
										refresh={refresh}
										focusSearch={focusSearch}
										searchValue ={searchValue}
										isInventory={false}
									/>
								</div>
							</>
						}
					{
						stepFlaw === 0 &&
							<>
								{/* left side section */}
							<LeftSideWrapper fullWidth={isTablet}>
								<>
									{ listKeys && listKeys.map((elm, i) => {
										return (
												<GroupItems
													key={elm}
													canEdit={canEdit}
													name={elm}
													list={receptionData[elm]}
													last={(i === listKeys.length - 1)}
													isTablet={isTablet}
													onCardClick={handleCardClick}
													selectedCard={selectedCard}
												/>
											)
										})
									}

									{/* Button for flaw (break) */}
									<ButtonFlaw isTablet={true} onSetFlaw={onSetFlaw} addButton={true} addAction={handleOpenListModal}/>
								</>
							</LeftSideWrapper>

							{/* Right side section */}
							{!isTablet &&
								<RightSideWrapper>
										{getAction()}
								</RightSideWrapper>
							}
						</>
					}

					{
						stepFlaw !== 0 && !isTablet && getAction()
					}

						{/*
						  * Modal for input. `isTablet` is recomputed on every resize, but `open`
						  * is only set when the declaration starts. Starting one on a desktop
						  * width and then narrowing the window left the form rendered nowhere,
						  * with no page chrome left to click either. The modal follows the step,
						  * not the order of the two switches.
						  */}
						{ isTablet &&
								<ModalWrapper
										open={open || stepFlaw > 0}
										handleClose={handleCloseModal}
								>
										{getAction()}
								</ModalWrapper>
						}

					{ listToShow.length > 0 &&
						<ListToShowTable
							open={openList}
							onClose={handleCloseListModal}
							data={listToShow}
							productSelected={productSelected}
							onAddProduct={toggleProduct}
							validateDisplay={validateDisplay}
						/>
					}

					{/* Error snackbar */}
					<ReceptionSnackBar data={receptionSnackBar} onClose={closeReceptionDetailSnackBar} />

						{/* apply styles adjustments */}
						<GlobalStyles />
				</FullScreenWrapper>
		)
}

export default connect((state) => {
		return {
				selectedDate: state.reception.date,
			selectedHub: state.reception.hub,
			formattedReceptionData: state.reception.receptionData,
			receptionSnackBar: state.reception.receptionDetailSnackBar,
			update: state.reception.update,
			originalReceptionData: state.reception.originalReceptionData,
			canEdit: state.app.rights[CAN_UPDATE_PRODUCT_STOCK],
			noDisplay: state.reception.noDisplay
		}
}, {
		showReceptionInterface,
	updateProductStock,
	updateStatus,
	resetStatus,
	filterByStatus,
	filterByNameOrCode,
	closeReceptionDetailSnackBar,
	showErrors,
	loadReception,
	validateAddDisplay
})(Reception)
